import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { ErrorBaseComponent } from '../error-base/error-base.component';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './404.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ErrorBaseComponent],
})
export class PageNotFoundComponent {
  public currentUrl: string = null;
  public errorUrl: string = null;

  constructor(private readonly router: Router) {
    this.currentUrl = this.router.url;
    const navigation = this.router.currentNavigation();
    // errorUrl param sent from the error.interceptor
    this.errorUrl = navigation?.extras?.state?.errorUrl;
  }
}
